<a [href]="dataList.link || dataList.Link" target="_blank">
<div class="flex justify-between items-center w-full h-full bg-white rounded-md border border-gray-ds p-[6px]">
    <div class="flex">
        <img *ngIf="dataList.pictureUrl"  [ngSrc]="dataList.pictureUrl"  (error)="dataList.pictureUrl =  'assets/images/empty-city.jpg'"
        alt="add-city" class="!h-[68px] !w-[68px] rounded-[4px]" width="68" height="68" />
        <div class="mr-md">
            <p *ngIf="dataList.name">
                <span class="font-normal text-p ml-sm">کشور</span>
                <span class="font-bold text-p">{{dataList.name}} </span>
            </p>
            <p>
                <span *ngIf="dataList.Title" class="text-gray-ds-900 inline-block text-xs lg:text-base !leading-8">{{ dataList.Title }}</span>
                <span *ngIf="dataList.BoldTitle" class="text-gray-ds-900 font-bold mr-1 mt-1 inline-block text-xs lg:text-base">{{ dataList.BoldTitle ? dataList.BoldTitle : 'بدون عنوان بولد' }}</span>
            </p>
            <p *ngIf="dataList.hotelName">
                <span class="font-bold text-p">{{dataList.hotelName}} </span>
            </p>
            <p class="flex items-center mt-1" *ngIf="dataList.totalAccommodations || dataList.TotalAccommodations">
               <i class="iho-icon-city-01 text-xl text-gray-ds-400"></i>
               <span class="text-gray-ds-400 text-xs mx-sm"> {{dataList.totalAccommodations || dataList.TotalAccommodations}} </span>
               <span class="text-gray-ds-400 text-xs">واحد اقامتی</span>
            </p>
            <p class="flex" *ngIf="dataList.stars">
                <i class="iho-icon-star text-xl text-gray-ds-400"></i>
                <span class="text-gray-ds-400 text-small mx-sm"> {{dataList.stars}} ستاره</span>
            </p>
        </div>
    </div>
    <i class="iho-icon-arrow-left-01-sharp mr-2 text-sm lg:text-3xl text-gray-ds-200"></i>
</div>
</a>